<ui-grid-col spaced>
	<ui-grid-header path="Notifications" icon="wq wq-alert">
		<button *ngIf="inbox.app.orgInfo?.role.is_elevated" class="btn btn-purple mr-2" (click)="inbox.alertEditModal.open('new')"><i class="wq wq-add mr-2"></i>Create Announcement</button>
		<button *ngIf="inbox.app.alertCount" class="btn btn-primary" (click)="inbox.dismissAll()"><i class="wq wq-check mr-2"></i>Mark all as read</button>
	</ui-grid-header>
	<ui-grid-row>
		<ui-grid-col weight-2>
			<app-alert-inbox #inbox></app-alert-inbox>
		</ui-grid-col>
	</ui-grid-row>
</ui-grid-col>
